import { useIdvMachine } from '../../components/machine-provider';

export default useIdvMachine;
